import { connect } from 'react-redux';

import TimeOfDayFilter from './TimeOfDayFilter';
import { trackFilterClickSpecialHours } from '../../../../actions';

const mapDispatchToProps = {
    trackFilterClickSpecialHours,
};

export default connect(undefined, mapDispatchToProps)(TimeOfDayFilter);
